import type { ProductUrlType } from '@noths/polaris-dev-ts-types';
import { createAction } from '@reduxjs/toolkit';

interface ProductClickPayload {
  destinationUrl: ProductUrlType;
  productUrl: ProductUrlType;
  productCode: number;
  linkOpensInSameWindow: boolean;
}

export const productListClick = createAction<ProductClickPayload>('products/productListClick');
